import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import CTAButton from "./CTAButton";
import { CONNECT_URL, CONNECT_URL_IS_EXTERNAL } from "@/config/links";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Our Programs", path: "/programs" },
  { label: "Practices", path: "/practices" },
  { label: "TOOLS", path: "/tools" },
  { label: "Former Players", path: "/former-players" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-onyx-50/95 backdrop-blur-md border-b border-gunmetal-50"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <img
              src="https://mbqtdfdhqbpbcfqzdbso.supabase.co/storage/v1/object/public/site-assets/triumph-logo-header.png"
              alt="Triumph Basketball"
              className="h-12 w-auto md:h-16"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-body text-sm font-medium tracking-wide uppercase transition-colors ${
                  location.pathname === item.path
                    ? "text-strike-500"
                    : "text-white/70 hover:text-white"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <CTAButton
              variant="nav"
              size="sm"
              {...(CONNECT_URL_IS_EXTERNAL ? { href: CONNECT_URL } : { to: CONNECT_URL })}
            >
              Register
            </CTAButton>
          </nav>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-onyx-50/98 backdrop-blur-md border-t border-gunmetal-50">
          <div className="px-4 py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-body text-sm font-medium tracking-wide uppercase py-2 ${
                  location.pathname === item.path
                    ? "text-strike-500"
                    : "text-white/70"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <CTAButton
              variant="nav"
              size="md"
              {...(CONNECT_URL_IS_EXTERNAL ? { href: CONNECT_URL } : { to: CONNECT_URL })}
              className="mt-2 w-full text-center"
            >
              Register
            </CTAButton>
          </div>
        </div>
      )}
    </header>
  );
}